export class UserGetters {
  public static getUser = 'getUser';
  public static getRole = 'getRole';
  public static isAuthenticated = 'isAuthenticated';

  public static isSuperAdmin = 'isSuperAdmin';
  public static isAdmin = 'isAdmin';
  public static isParent = 'isParent';
}

export class CartGetters {
  public static getCourses = 'getCartCourses';
  public static getCoupon = 'getCoupon';
}